export const CHAT = {
  AGENTS: "chat-agents",
  CONVERSATIONS: "chat-conversations",
  CONVERSATIONS_EXPIRED: "chat-conversationsExpired",
  CONVERSATIONS_UNASSIGNED: "chat-conversationsUnassigned",
  EVENTS: "chat-events",
  LINES: "chat-lines",
  QUICKLY_REPLIES: "chat-quicklyReplies"
};